import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { savePositionFailed, savePositionSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* savePosition(action) {
  try {
    const { id, data } = action.payload;
    const url = `${BACKEND_URL}/api/v1/position/${id}`;
    const dataResponse = yield makeRequest(url, data, action, 'PUT', true);
    if (dataResponse.status === OK) {
      yield put(savePositionSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(savePositionFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(savePositionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
